import revive_payload_client_4sVQNw7RlN from "/opt/atlassian/pipelines/agent/build/public-pages/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import vuetify_icons_KAumv2pUni from "/opt/atlassian/pipelines/agent/build/public-pages/node_modules/vuetify-nuxt-module/dist/runtime/plugins/vuetify-icons.js";
import unhead_KgADcZ0jPj from "/opt/atlassian/pipelines/agent/build/public-pages/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/opt/atlassian/pipelines/agent/build/public-pages/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/opt/atlassian/pipelines/agent/build/public-pages/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/opt/atlassian/pipelines/agent/build/public-pages/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/opt/atlassian/pipelines/agent/build/public-pages/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/opt/atlassian/pipelines/agent/build/public-pages/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/opt/atlassian/pipelines/agent/build/public-pages/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/opt/atlassian/pipelines/agent/build/public-pages/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/opt/atlassian/pipelines/agent/build/public-pages/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import vuetify_no_client_hints_kyYn5AnnAK from "/opt/atlassian/pipelines/agent/build/public-pages/node_modules/vuetify-nuxt-module/dist/runtime/plugins/vuetify-no-client-hints.js";
import froala_vp7jhZPNyZ from "/opt/atlassian/pipelines/agent/build/public-pages/plugins/froala.js";
import chartjs_client_22DCMFgtqN from "/opt/atlassian/pipelines/agent/build/public-pages/plugins/chartjs.client.js";
import countdown_client_bKr9uVgsio from "/opt/atlassian/pipelines/agent/build/public-pages/plugins/countdown.client.js";
import event_bus_JNcXIfrhYt from "/opt/atlassian/pipelines/agent/build/public-pages/plugins/event-bus.js";
import vuedraggable_client_66gpqrYGrv from "/opt/atlassian/pipelines/agent/build/public-pages/plugins/vuedraggable.client.js";
import vueperslides_client_NWKjIlgCUj from "/opt/atlassian/pipelines/agent/build/public-pages/plugins/vueperslides.client.js";
import vuetify_7h9QAQEssH from "/opt/atlassian/pipelines/agent/build/public-pages/plugins/vuetify.ts";
import vuetify_nuxt_plugin_client_JOtFoHdxcp from "/opt/atlassian/pipelines/agent/build/public-pages/.nuxt/vuetify-nuxt-plugin.client.mjs";
export default [
  revive_payload_client_4sVQNw7RlN,
  vuetify_icons_KAumv2pUni,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  vuetify_no_client_hints_kyYn5AnnAK,
  froala_vp7jhZPNyZ,
  chartjs_client_22DCMFgtqN,
  countdown_client_bKr9uVgsio,
  event_bus_JNcXIfrhYt,
  vuedraggable_client_66gpqrYGrv,
  vueperslides_client_NWKjIlgCUj,
  vuetify_7h9QAQEssH,
  vuetify_nuxt_plugin_client_JOtFoHdxcp
]